<div>
  <div class="row">
    <strong class="col-4">{{direction}}:</strong>
  </div>
  <div class="row mt-3" *ngIf="dbInfo?.CustomerId">
    <div class="col-4">Customer Id:</div>
    <div class="col-8">{{dbInfo?.CustomerId}}</div>
  </div>
  <div class="row mt-3" *ngIf="dbInfo?.TargetBkpName">
    <div class="col-4">Target Backup Name:</div>
    <div class="col-8">{{dbInfo?.TargetBkpName}}</div>
  </div>
  <div class="row">
    <div class="col-4">DB:</div>
    <div class="col-8">{{dbInfo?.Db}}</div>
  </div>
  <div class="row">
    <div class="col-4">Env:</div>
    <div class="col-8">{{dbInfo?.Env}}</div>
  </div>
  <div class="row">
    <div class="col-4">Server:</div>
    <div class="col-8">{{dbInfo?.Server}}</div>
  </div>
  <div class="row">
    <div class="col-4">Subscription:</div>
    <div class="col-8">{{dbInfo?.Subscription}}</div>
  </div>
  <div class="row mt-2">
    <kendo-formfield class="form-group col-12" *ngIf="control">
      <kendo-label
        [for]="confirm"
        class="k-checkbox-label"
        text="Confirm:"
      >
      </kendo-label>
      <input
        #confirm
        type="checkbox"
        name="confirm"
        value="true"
        [formControl]="control"
        kendoCheckBox/>
    </kendo-formfield>
  </div>
</div>
